import { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Loader2, LogOut } from "lucide-react";
import { toast } from "sonner";
import api, { formatError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CLINICAL_AGREEMENT as A, CLINICAL_AGREEMENT_VERSION } from "../content/legal";

export function ClinicalAgreementGate() {
  const { refreshUser, logout } = useAuth();
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/clinical-agreement", { version: CLINICAL_AGREEMENT_VERSION, confirmed: true });
      await refreshUser();
      toast.success("Agreement accepted");
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-10" data-testid="clinical-agreement-gate">
      <div className="w-full max-w-2xl bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
        <div className="bg-[#0B2545] text-white px-6 py-5">
          <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-[#16B5A6]"><ShieldCheck className="w-4 h-4" /> Required before using DentiCision</p>
          <h1 className="font-heading text-2xl font-bold mt-2">{A.title}</h1>
          <p className="text-xs text-slate-300 mt-1">Version {CLINICAL_AGREEMENT_VERSION}</p>
        </div>
        <div className="px-6 py-5 max-h-[55vh] overflow-y-auto text-sm text-slate-700 leading-relaxed" data-testid="clinical-agreement-text">
          <p>{A.intro}</p>
          <ol className="mt-4 space-y-3">
            {A.points.map((p, i) => (
              <li key={i} className="flex gap-3"><span className="shrink-0 w-6 h-6 rounded-full bg-slate-100 text-[#0B2545] text-xs font-bold flex items-center justify-center">{i + 1}</span><span>{p}</span></li>
            ))}
          </ol>
        </div>
        <div className="px-6 py-5 border-t border-slate-200 bg-slate-50">
          <label className="flex items-start gap-3 cursor-pointer" data-testid="clinical-agreement-confirm-label">
            <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} data-testid="clinical-agreement-checkbox" className="mt-1 w-4 h-4 accent-[#1C6FE3]" />
            <span className="text-sm font-medium text-slate-900">{A.confirm}</span>
          </label>
          <div className="mt-5 flex flex-wrap items-center gap-3 justify-between">
            <button type="button" onClick={logout} data-testid="clinical-agreement-logout" className="inline-flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-800"><LogOut className="w-4 h-4" /> Log out</button>
            <div className="flex items-center gap-4">
              <Link to="/clinical-agreement" target="_blank" className="text-sm text-[#1C6FE3] font-medium" data-testid="clinical-agreement-public-link">Printable version</Link>
              <button type="button" disabled={!ok || busy} onClick={accept} data-testid="clinical-agreement-accept"
                className="inline-flex items-center gap-2 rounded-full bg-[#1C6FE3] hover:bg-[#1559BC] disabled:opacity-40 disabled:cursor-not-allowed text-white font-semibold px-6 h-11 transition-colors">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} I Agree &amp; Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
